import { apiClient } from './client';

export interface Section {
  _id: string;
  sectionId: string;
  name: string;
  description: string;
  thumbnail?: string;
  isActive: boolean;
}

export interface Layout {
  _id: string;
  layoutId: string;
  name: string;
  sectionId: string;
  description: string;
  thumbnail?: string;
  isActive: boolean;
}

export interface LayoutsForSection {
  section: Section;
  layouts: Layout[];
}

export interface RecommendedImageSize {
  width: number;
  height: number;
  note?: string;
}

export interface ContentField {
  name: string;
  label: string;
  type: 'text' | 'textarea' | 'richtext' | 'image' | 'url' | 'email' | 'phone' | 'array';
  placeholder?: string;
  required?: boolean;
  arrayFields?: ContentField[];
  /** For type "image" fields: the ideal upload dimensions for this spot in the layout. */
  recommendedSize?: RecommendedImageSize;
}

export interface ContentSchema {
  layoutId: string;
  layoutName: string;
  fields: ContentField[];
}

export const sectionApi = {
  // Get all sections (master data)
  getAllSections: async (): Promise<Section[]> => {
    const response = await apiClient.get('/business/sections');
    return response.data.data;
  },

  // Get layouts for a specific section
  getLayoutsForSection: async (sectionId: string): Promise<LayoutsForSection> => {
    const response = await apiClient.get(`/business/sections/${sectionId}/layouts`);
    return response.data.data;
  },

  // Get content schema for a layout
  getContentSchema: async (layoutId: string): Promise<ContentSchema> => {
    const response = await apiClient.get(`/business/content/schema/${layoutId}`);
    return response.data.data;
  },
};
